module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-73077d16c654bffb16d51d5d8063b600.png";